<div style="width:100%;">
  <div>
    <form #fileUploadForm="ngForm">
      <div class="form-group mb-3">
        <input style="min-width: 120px;" type="text" class="form-control" placeholder="Format Name"
          name="formatName" [(ngModel)]="formatName">
        </div>
        @if (fetchType.valueOf() === 'CSV-UPLOAD') {
          <span>
            <div class="form-group">
              <label for="separator">{{ 'CSV-UPLOAD.SEPARATOR' | translate }}</label>
              <select [(ngModel)]="separator" id="separator" class="form-control" name="separator">
                @for (value of separators; track value) {
                  <option value="{{value}}">
                    {{ value }}
                  </option>
                }
              </select>
            </div>
            <div class="form-group">
              <input type="file" id="fileUpload" class="form-control" name="fileUpload" #fileUpload ng2FileSelect
                [uploader]="uploader"/>
              </div>
              <div class="form-check form-switch">
                <input type="checkbox" class="form-check-input" id="hasHeader" [checked]="hasHeader"
                  (change)="hasHeader = !hasHeader" name="hasHeader">
                  <label for="hasHeader" class="form-check-label">{{ 'CSV-UPLOAD.HAS_HEADER' | translate }}</label>
                </div>
                @if (dateFields.length) {
                  <div class="form-check form-switch">
                    <input type="checkbox" class="form-check-input" id="splitByYear"
                      [checked]="splitByYear" (change)="splitByYear = !splitByYear" name="splitByYear">
                      <label for="splitByYear" class="form-check-label">{{ 'CSV-UPLOAD.SPLIT_BY_YEAR' | translate }}</label>
                    </div>
                  }
                  @if (splitByYear && dateFields.length) {
                    <div class="form-group mt-2">
                      <label for="yearDateField">{{ 'CSV-UPLOAD.YEAR_DATE_FIELD' | translate }}</label>
                      <select id="yearDateField" class="form-control" name="yearDateField" [(ngModel)]="yearDateField">
                        @for (f of dateFields; track f) {
                          <option [value]="f.name">
                            {{ f.alias?.trim()?.length ? f.alias : f.name }}
                          </option>
                        }
                      </select>
                    </div>
                  }
                  <div class="form-check form-switch">
                    <input type="checkbox" class="form-check-input" id="fluxCsv"
                      [checked]="flux" (change)="flux = !flux" name="flux">
                      <label for="fluxCsv" class="form-check-label">{{ 'CSV-UPLOAD.FLUX_COLUMN' | translate }}</label>
                    </div>
                  </span>
                }
                @if (fetchType.valueOf() === 'API-GATEWAY') {
                  <span>
                    <div class="form-group mb-3">
                      <label for="apiGateway">{{ 'SERVICE-API.API_GATEWAY' | translate }}</label>
                      <ng-select
                        name="apiGateway"
                        [items]="apiGateways"
                        bindLabel="name"
                        [placeholder]="'SERVICE-API.SELECT' | translate"
                        [virtualScroll]="true" [searchable]="false"
                        [(ngModel)]="externalApiGateway.api">
                      </ng-select>
                    </div>
                    <div class="form-group mb-3">
                      <div class="form-check form-switch">
                        <input class="form-check-input" type="checkbox" role="switch" id="switchCheckDefault" name="autoRefresh" (change)="externalApiGateway.autoRefetch = $event.target.checked"
                          [(ngModel)]="externalApiGateway.autoRefetch">
                          <label class="form-check-label"
                          for="switchCheckDefault">{{ 'SERVICE-API.AUTO_REFETCH' | translate }}</label>
                        </div>
                      </div>
                      <div class="form-group mb-3">
                        <label for="url">{{ 'SERVICE-API.JOB_DAYS' | translate }}</label>
                        <input type="number" [min]="0" [max]="30" class="form-control"
                          [placeholder]="'SERVICE-API.JOB_DAYS_PLACEHOLDER' | translate" name="days"
                          [(ngModel)]="externalApiGateway.refetchAfterDays">
                        </div>
                        <div class="form-check form-switch">
                          <input type="checkbox" class="form-check-input" id="fluxApi"
                            [checked]="flux" (change)="flux = !flux" name="flux">
                            <label for="fluxApi" class="form-check-label">{{ 'CSV-UPLOAD.FLUX_COLUMN' | translate }}</label>
                          </div>
                          <hr/>
                          <div>
                            <button type="button" class="btn btn-primary btn-s" (click)="fetchMetaData()" [disabled]="!externalApiGateway?.api || fetching">
                              @if (fetching) {
                                <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                <span role="status">Fetching...</span>
                              }
                              @if (!fetching) {
                                {{'SERVICE-API.FETCH_META' | translate}}
                              }
                            </button>
                          </div>
                        </span>
                      }
                    </form>
                  </div>
                  <div class="mt-2">

                    @if (fileFormat==null) {
                      <table class="table">
                        <thead>
                          <tr>
                            <th class="header-text-style" width="50%">{{ 'CSV-UPLOAD.NAME' | translate }}</th>
                            <th class="header-text-style">{{ 'CSV-UPLOAD.SIZE' | translate }}</th>
                            <th class="header-text-style">{{ 'CSV-UPLOAD.ACTIONS' | translate }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (item of uploader.queue; track item) {
                            <tr>
                              <td><strong>{{ item.file.name }}</strong></td>
                              <td nowrap>{{ item.file.size / 1024 / 1024 | number:'.2' }} MB</td>
                              <td nowrap>
                              </td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    }


                    <div style="border: 1px solid var(--border); overflow: auto;">
                      @if (fileFormat!=null) {
                        <table border="1">
                          <tr>
                            @for (item of visibleMappingObjects; track item; let i = $index) {
                              <td>
                                @if (fileFormat.mappingObjects[i]['type']==4 || fileFormat.mappingObjects[i]['type']==11) {
                                  <input type="text" class="form-control"
                                    name="dateFormat" value="{{fileFormat.mappingObjects[i]['format']}}"
                                    placeholder="date format" (change)="addFormatToMapping($event.target.value,i)">
                                }
                                @if (fileFormat.mappingObjects[i]['type']==5) {
                                  <select style="min-width: 120px;" class="form-control"
                                    name="currencyCode" (change)="addCurrencyCodeToMapping($event.target.value,i)">
                                    <option value="" [selected]="!fileFormat.mappingObjects[i]['currencyCode']">&mdash;</option>
                                    @for (code of conversionCodes; track code) {
                                      <option [value]="code"
                                      [selected]="fileFormat.mappingObjects[i]['currencyCode'] === code">{{ code }}</option>
                                    }
                                  </select>
                                }
                              </td>
                            }
                          </tr>
                          <tr>
                            @for (item of visibleMappingObjects; track item; let i = $index) {
                              <td>
                                <select style="min-width: 120px;" class="form-control" name="defaultFileFormat"
                                  (change)="onChange($event.target.value,i);">
                                  @for (value of mappingDropdown; track value) {
                                    <option value={{value.value}}
                                      [selected]="item.type == value.value">
                                      {{ value.name }}
                                    </option>
                                  }
                                </select>
                              </td>
                            }
                          </tr>
                          <tr>
                            @for (item of visibleMappingObjects; track item; let i = $index) {
                              <td>
                                <input style="min-width: 120px;" type="text" class="form-control" placeholder="name" name="name"
                                  value="{{item.name}}" (change)="addNameToMapping($event.target.value,i)">
                                </td>
                              }
                            </tr>
                            <tr>
                              @for (item of visibleMappingObjects; track item; let i = $index) {
                                <td>
                                  <div class="form-check form-switch">
                                    <input type="checkbox" class="form-check-input"
                                      [checked]="item.showInPayeeDataset"
                                      (change)="item.showInPayeeDataset = !item.showInPayeeDataset"
                                      name="showInPayeeDataset">
                                      <label class="form-check-label"><span>{{'CSV-UPLOAD.SHOW_IN_PAYEE_DATASET' | translate}}</span></label>
                                    </div>
                                  <div class="form-check form-switch">
                                    <input type="checkbox" class="form-check-input"
                                      [checked]="item.hiddenInPortal"
                                      (change)="item.hiddenInPortal = !item.hiddenInPortal"
                                      name="hiddenInPortal">
                                      <label class="form-check-label"><span>{{'PORTAL.HIDE_COLUMN' | translate}}</span></label>
                                    </div>
                                  </td>
                                }
                              </tr>
                              <tr>
                                @for (item of visibleMappingObjects; track item; let i = $index) {
                                  <td>
                                    <input style="min-width: 120px;" type="text" class="form-control" placeholder="alias"
                                      name="alias" value="{{item.alias}}"
                                      (change)="addAliasToMapping($event.target.value,i)">
                                    </td>
                                  }
                                </tr>
                                <tr>
                                  @for (item of visibleMappingObjects; track item; let i = $index) {
                                    <td>
                                      <input style="min-width: 120px;" type="text" class="form-control" placeholder="description"
                                        name="description" value="{{item.description}}"
                                        (change)="addDescriptionToMapping($event.target.value,i)">
                                      </td>
                                    }
                                  </tr>
                                  @if (fetchType.valueOf() === 'CSV-UPLOAD') {
                                    @for (item of fileFormat['sample']; track item) {
                                      <tr>
                                        @if (item!==undefined && isArray(item)) {
                                          @for (data of item; track data) {
                                            <td>
                                              <span class="hideextra">{{ data }}</span>
                                            </td>
                                          }
                                        }
                                      </tr>
                                    }
                                  }
                                  @if (fetchType.valueOf() === 'API-GATEWAY') {
                                    <tr>
                                      @for (field of fileFormat['fields']; track field) {
                                        <td>
                                          <span class="">{{ field }}</span>
                                        </td>
                                      }
                                    </tr>
                                    @for (item of fileFormat['sample']; track item) {
                                      <tr>
                                        @for (field of fileFormat['fields']; track field) {
                                          <td>
                                            <span class="">{{ item[field] }}</span>
                                          </td>
                                        }
                                      </tr>
                                    }
                                  }
                                </table>
                              }

                              <div class="table-responsive">
                                @if (dataRows!=null) {
                                  <table border="1" class="table table-striped table-hover">
                                    <tbody>
                                      @if (fetchType.valueOf() == 'CSV-UPLOAD' && separator) {
                                        @for (item of dataRows.slice(0,1) ; track item) {
                                          <tr>
                                            @for (row of item.split(separator); track row; let i = $index) {
                                              <td>
                                                @if (mappingObjects[i]['type']==4 || mappingObjects[i]['type']==11) {
                                                  <input type="text" class="form-control" name="dateFormat"
                                                    value="" placeholder="date format" (change)="addFormatToMapping($event.target.value,i)">
                                                }
                                                @if (mappingObjects[i]['type']==5) {
                                                  <select style="min-width: 120px;" class="form-control"
                                                    name="currencyCode" (change)="addCurrencyCodeToMapping($event.target.value,i)">
                                                    <option value="" [selected]="!mappingObjects[i]['currencyCode']">&mdash;</option>
                                                    @for (code of conversionCodes; track code) {
                                                      <option [value]="code"
                                                      [selected]="mappingObjects[i]['currencyCode'] === code">{{ code }}</option>
                                                    }
                                                  </select>
                                                }
                                              </td>
                                            }
                                          </tr>
                                        }
                                        @for (item of dataRows.slice(0,1); track item) {
                                          <tr>
                                            @for (row of item.split(separator); track row; let i = $index) {
                                              <td>
                                                <select style="min-width: 120px;" class="form-control" name="defaultFileFormat"
                                                  (change)="onChange($event.target.value,i);">
                                                  @for (value of mappingDropdown; track value) {
                                                    <option value={{value.value}}>
                                                      {{ value.name }}
                                                    </option>
                                                  }
                                                </select></td>
                                              }
                                            </tr>
                                          }
                                          @for (item of dataRows.slice(0,1); track item) {
                                            <tr>
                                              @for (row of item.split(separator); track row; let i = $index) {
                                                <td>
                                                  <input style="min-width: 120px;" type="text" class="form-control" placeholder="name"
                                                    name="name" (change)="addNameToMapping($event.target.value,i)">
                                                  </td>
                                                }
                                              </tr>
                                            }
                                            @for (item of dataRows.slice(0,1); track item) {
                                              <tr>
                                                @for (row of item.split(separator); track row; let i = $index) {
                                                  <td>
                                                    <input style="min-width: 120px;" type="text" class="form-control" placeholder="alias"
                                                      name="alias" (change)="addAliasToMapping($event.target.value,i)">
                                                    </td>
                                                  }
                                                </tr>
                                              }
                                              @for (item of dataRows.slice(0,1); track item) {
                                                <tr>
                                                  @for (row of item.split(separator); track row; let i = $index) {
                                                    <td>
                                                      <input style="min-width: 120px;" type="text" class="form-control" placeholder="description"
                                                      name="description" (change)="addDescriptionToMapping($event.target.value,i)"></td>
                                                    }
                                                  </tr>
                                                }
                                                @for (item of dataRows; track item) {
                                                  <tr>
                                                    @for (row of item.split(separator); track row) {
                                                      <td>
                                                        <span class="hideextra">{{ row }}</span>
                                                      </td>
                                                    }
                                                  </tr>
                                                }
                                              }
                                              @if (fetchType.valueOf() === 'API-GATEWAY') {
                                                <tr>
                                                  @for (field of dataRows['fields']; track field; let i = $index) {
                                                    <td>
                                                      @if (mappingObjects[i]['type']==4 || mappingObjects[i]['type']==11) {
                                                        <input type="text" class="form-control" name="dateFormat"
                                                          value="{{mappingObjects[i]['dateFormat']}}" placeholder="date format" (change)="addFormatToMapping($event.target.value,i)">
                                                      }
                                                      @if (mappingObjects[i]['type']==5) {
                                                        <select style="min-width: 120px;" class="form-control"
                                                          name="currencyCode" (change)="addCurrencyCodeToMapping($event.target.value,i)">
                                                          <option value="" [selected]="!mappingObjects[i]['currencyCode']">&mdash;</option>
                                                          @for (code of conversionCodes; track code) {
                                                            <option [value]="code"
                                                            [selected]="mappingObjects[i]['currencyCode'] === code">{{ code }}</option>
                                                          }
                                                        </select>
                                                      }
                                                    </td>
                                                  }
                                                </tr>
                                                <tr>
                                                  @for (field of dataRows['fields']; track field; let i = $index) {
                                                    <td>
                                                      <select style="min-width: 120px;" class="form-control" name="defaultFileFormat"
                                                        (change)="onChange($event.target.value,i);">
                                                        @for (value of mappingDropdown; track value) {
                                                          <option value={{value.value}}>
                                                            {{ value.name }}
                                                          </option>
                                                        }
                                                      </select></td>
                                                    }
                                                  </tr>
                                                  <tr>
                                                    @for (field of dataRows['fields']; track field; let i = $index) {
                                                      <td>
                                                        <input style="min-width: 120px;" type="text" class="form-control" placeholder="name"
                                                          name="name" value="{{mappingObjects[i]['name']}}" (change)="addNameToMapping($event.target.value,i)">
                                                        </td>
                                                      }
                                                    </tr>
                                                    <tr>
                                                      @for (field of dataRows['fields']; track field; let i = $index) {
                                                        <td>
                                                          <input style="min-width: 120px;" type="text" class="form-control" placeholder="alias"
                                                            name="alias" value="{{mappingObjects[i]['alias']}}" (change)="addAliasToMapping($event.target.value,i)">
                                                          </td>
                                                        }
                                                      </tr>
                                                      <tr>
                                                        @for (field of dataRows['fields']; track field; let i = $index) {
                                                          <td>
                                                            <input style="min-width: 120px;" type="text" class="form-control" placeholder="description"
                                                            name="description" value="{{mappingObjects[i]['description']}}" (change)="addDescriptionToMapping($event.target.value,i)"></td>
                                                          }
                                                        </tr>
                                                        <tr>
                                                          @for (field of dataRows['fields']; track field) {
                                                            <td>
                                                              <span class="">{{ field }}</span>
                                                            </td>
                                                          }
                                                        </tr>
                                                        @for (item of dataRows['data']; track item) {
                                                          <tr>
                                                            @for (field of dataRows['fields']; track field) {
                                                              <td>
                                                                <span class="">{{ item[field] }}</span>
                                                              </td>
                                                            }
                                                          </tr>
                                                        }
                                                      }
                                                    </tbody>
                                                  </table>
                                                }

                                              </div>
                                            </div>

                                            <app-special-columns-editor
                                              [columns]="sourceColumns"
                                              [(specialColumns)]="specialColumns">
                                            </app-special-columns-editor>

                                            <hr/>
                                            <div>

                                              @if (fetchType.valueOf() === 'CSV-UPLOAD') {
                                                <button type="button" class="btn btn-danger btn-s" (click)="apply()"
                                                  [disabled]="!uploader.queue.length && fileFormat==null">
                                                  <span class="glyphicon glyphicon-ok"></span> {{ 'CSV-UPLOAD.APPLY' | translate }}
                                                </button>
                                              }
                                              @if (fetchType.valueOf() === 'API-GATEWAY') {
                                                <button type="button" class="btn btn-danger btn-s" (click)="apply()"
                                                  [disabled]="!externalApiGateway?.api && fileFormat==null">
                                                  <span class="glyphicon glyphicon-ok"></span> {{ 'CSV-UPLOAD.APPLY' | translate }}
                                                </button>
                                              }
                                              <button type="button" class="btn btn-warning btn-s" (click)="closeWindow();fileUploadForm.reset()">
                                                <span class="glyphicon glyphicon-ban-circle"></span> {{ 'CSV-UPLOAD.CANCEL' | translate }}
                                              </button>
                                            </div>
                                          </div>
                                        </div>


                                        <ng-template #informationTemplate>
                                          <div class="modal-body text-center">
                                            <p>{{ errorMessage | translate }}</p>
                                            <button type="button" class="btn btn-outline-secondary"
                                              (click)="closeModal(template);">{{ 'CSV-UPLOAD.OK' | translate }}
                                            </button>

                                          </div>
                                        </ng-template>
